import React from 'react';
import BlankModal from './BlankModal';
import { useState } from 'react';

export interface RevokeConfirmModalProps {
  isVisible: boolean;
  credentialName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

/**
 * DeleteConfirmModal component
 *
 * @param {*} {
 *   isVisible,
 *   onClose,
 *   onConfirm
 * }
 * @return {*}
 */
const RevokeConfirmModal: React.FC<RevokeConfirmModalProps> = ({
  isVisible,
  onClose,
  onConfirm,
  credentialName
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
    onClose();
  };
  return (
    <BlankModal
      title={`Revoke ${credentialName}?`}
      isVisible={isVisible}
      onClose={onClose}
      onConfirm={() => handleConfirm()}
      acceptText="Confirm"
      isLoading={isLoading}>
      <></>
    </BlankModal>
  );
};

export default RevokeConfirmModal;
